import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { BRAND_ASSETS } from '../branding';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', mot_de_passe: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const loginBackgroundPath = `${process.env.PUBLIC_URL}/${encodeURIComponent('ChatGPT Image 22 mai 2026, 03_49_36.png')}`; // Chemin vers l'image de fond dans le dossier public

  const loginPageStyle = {
    backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.45), rgba(15, 23, 42, 0.25)), url("${loginBackgroundPath}")`,
  };

  const handleChange = (event) => {
    setForm((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(form.email, form.mot_de_passe);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.message || 'Connexion impossible');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" style={loginPageStyle}>
      <div className="login-card">
        <div className="login-brand-block">
          <img className="login-brand-logo" src={BRAND_ASSETS.logoFull} alt="VeriPlan" />
          <p className="subtitle">Connexion à votre espace</p>
        </div>

        {error && <div className="alert error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <label>
            Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Mot de passe
            <input
              type="password"
              name="mot_de_passe"
              value={form.mot_de_passe}
              onChange={handleChange}
              required
            />
          </label>

          <button type="submit" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="helper">
          <span>Pas encore de compte ?</span>
          <span className="muted">Inscription via l'administrateur.</span>
        </div>
      </div>
    </div>
  );
}
